import React from "react";
import { createUseStyles } from "react-jss";
import { Tooltip } from "@mui/material";
import { View, Text, Sizes } from "..";
import CustomTooltip from "../CustomTooltip";

export enum Cursor {
  POINTER = "pointer",
  NOT_ALLOWED = "not-allowed",
  DEFAULT = "default",
}

interface Props {
  onClick?: any;
  onDrag?: any;
  tooltipTitle?: any;
  dataTestId?: string;
  children?: React.ReactNode;
  style?: React.CSSProperties;
  className?: string;
  disabled?: boolean;
  cursor?: Cursor;
  ariaLabel?: string;
  title?: string;
}

const useStyles = createUseStyles({
  iconButtonContainer: {
    alignItems: "center",
    justifyContent: "center",
    "&:hover": {
      filter: "brightness(90%)",
      transition: "all 0.5s ease",
    },
  },
});

// usability: tooltipTitle mandatory
// IconButton as svg wrapper
export const IconButton: React.FC<Props> = ({
  onClick = null,
  onDrag = null,
  tooltipTitle = null,
  dataTestId = "",
  children,
  className = "",
  style = {},
  disabled,
  cursor = Cursor.POINTER,
  ariaLabel,
  title,
}) => {
  const styles = useStyles();

  return (
    <View
      className={`${styles.iconButtonContainer} ${className}`}
      data-testid={dataTestId}
      onClick={disabled ? null : onClick}
      onDrag={onDrag}
      ariaLabel={ariaLabel}
      title={title}
      style={
        disabled ? { ...style, cursor: "not-allowed" } : { ...style, cursor }
      }
    >
      {tooltipTitle ? (
        <Tooltip arrow title={<Text size={Sizes.small}>{tooltipTitle}</Text>}>
          <CustomTooltip>
            <View>{children}</View>
          </CustomTooltip>
        </Tooltip>
      ) : (
        <>{children}</>
      )}
    </View>
  );
};
